// filepath: z:\Active projects\E-commerce\ecommerce_client\src\components\common\PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
    const { token } = useSelector((state) => state.auth);

    if (!token) {
        return <Navigate to="/" />;
    }

    return children;
};

export default PrivateRoute;